import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="info-page terms">
      <Header />

      <div className="info-page__breadcrumb">
        <Link onClick={toTop} to="/">
          Home
        </Link>
        <span>/</span>
        <span>Terms & Conditions</span>
      </div>

      <div className="info-page__content">
        <div className="info-page__main">
          <h1 className="info-page__title">Terms & Conditions</h1>

          <p className="info-page__intro">Last updated: January 2024</p>

          <section className="info-section">
            <h2 className="info-section__title">Agreement to Terms</h2>
            <p>
              By accessing or using the Petmorvanto Brands website, you agree to
              be bound by these Terms and Conditions and all applicable laws and
              regulations. If you do not agree with any of these terms, you are
              prohibited from using or accessing this site.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">
              Intellectual Property Rights
            </h2>
            <p>
              The Petmorvanto Brands website and its original content, features,
              and functionality are owned by Petmorvanto Brands, Inc. and are
              protected by international copyright, trademark, patent, trade
              secret, and other intellectual property laws.
            </p>
            <p>
              You may not modify, copy, reproduce, republish, upload, post,
              transmit, or distribute any materials from this website without
              prior written permission.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">User Account</h2>
            <p>
              When you create an account with us, you guarantee that the
              information you provide is accurate, complete, and current at all
              times. Inaccurate, incomplete, or obsolete information may result
              in the immediate termination of your account.
            </p>
            <p>
              You are responsible for maintaining the confidentiality of your
              account and password, including but not limited to restricting
              access to your computer and account. You agree to accept
              responsibility for all activities that occur under your account or
              password.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Orders and Pricing</h2>
            <p>
              We reserve the right to refuse or cancel any orders placed for
              products listed at an incorrect price. We shall have the right to
              refuse or cancel any such orders whether or not the order has been
              confirmed and your credit card charged.
            </p>
            <p>
              If your order is cancelled after your credit card has been
              charged, we will refund the full amount to your original payment
              method.
            </p>
            <p>
              All prices are subject to change without notice. We reserve the
              right to modify or discontinue any product or service without
              notice at any time.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Shipping and Delivery</h2>
            <p>
              Please refer to our{" "}
              <Link to="/shipping" onClick={toTop}>
                Shipping Information
              </Link>{" "}
              page for details on shipping rates, delivery times, and
              international shipping policies.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Returns and Refunds</h2>
            <p>
              Please review our{" "}
              <Link to="/returns" onClick={toTop}>
                Return Policy
              </Link>{" "}
              for information about returns, refunds, and exchanges.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Disclaimer</h2>
            <p>
              Our website and products are provided "as is" and "as available"
              without warranties of any kind, either express or implied. We do
              not warrant that the website will be uninterrupted, secure, or
              error-free.
            </p>
            <p>
              We are not responsible for any direct, indirect, incidental,
              special, or consequential damages arising from the use of our
              products or website.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Limitation of Liability</h2>
            <p>
              In no event shall Petmorvanto Brands, Inc. or its suppliers be
              liable for any damages arising out of the use or inability to use
              the materials on the Petmorvanto Brands website, even if we have
              been notified of the possibility of such damage.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless Petmorvanto
              Brands, Inc. and our affiliates, partners, officers, directors,
              agents, contractors, licensors, service providers, subcontractors,
              suppliers, and employees from any claim or demand, including
              reasonable attorneys' fees, arising out of your use of the website
              or your violation of these Terms and Conditions.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Governing Law</h2>
            <p>
              These Terms and Conditions are governed by and construed in
              accordance with the laws of the United States, and you irrevocably
              submit to the exclusive jurisdiction of the courts in that State
              or location.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms and Conditions at any
              time. We will notify you of changes by posting the updated terms
              on this page with a new "Last updated" date.
            </p>
            <p>
              Your continued use of the website after any modifications
              indicates your acceptance of the updated Terms and Conditions.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Contact Information</h2>
            <p>
              Questions about the Terms and Conditions should be sent to us at:
            </p>
            <div className="contact-block">
              <p>9750 Royal Lane Dallas, TX 75231 United States</p>
              <p>split@petmorvanto.club</p>
            </div>
          </section>
        </div>

        <aside className="info-page__sidebar">
          <div className="sidebar-card">
            <h3 className="sidebar-card__title">Quick Links</h3>
            <ul className="sidebar-links">
              <li>
                <Link to="/privacy" onClick={toTop}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/returns" onClick={toTop}>
                  Return Policy
                </Link>
              </li>
              <li>
                <Link to="/shipping" onClick={toTop}>
                  Shipping Information
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
}

export default Terms;
